<template>
  <ion-page>
    <ion-content :fullscreen="true" class="app no-scroll">
      <div class="swipeListener" ref="rectangle" @click="newopencheck()"></div>
      <div class="logo">
        <span class="logo__s">S</span>lam<span class="logo__j">J</span>am<span
          class="logo__p"
          >P</span
        >oem
      </div>
      <div class="config">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 640 512"
          @click="openConfig"
        >
          <!--! Font Awesome Pro 6.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
          <path
            d="M286.3 155.1C287.4 161.9 288 168.9 288 175.1C288 183.1 287.4 190.1 286.3 196.9L308.5 216.7C315.5 223 318.4 232.1 314.7 241.7C312.4 246.1 309.9 252.2 307.1 257.2L304 262.6C300.1 267.6 297.7 272.4 294.2 277.1C288.5 284.7 278.5 287.2 269.5 284.2L241.2 274.9C230.5 283.8 218.3 290.9 205 295.9L198.1 324.9C197 334.2 189.8 341.6 180.4 342.8C173.7 343.6 166.9 344 160 344C153.1 344 146.3 343.6 139.6 342.8C130.2 341.6 122.1 334.2 121 324.9L114.1 295.9C101.7 290.9 89.5 283.8 78.75 274.9L50.53 284.2C41.54 287.2 31.52 284.7 25.82 277.1C22.28 272.4 18.98 267.5 15.94 262.5L12.92 257.2C10.13 252.2 7.592 247 5.324 241.7C1.62 232.1 4.458 223 11.52 216.7L33.7 196.9C32.58 190.1 31.1 183.1 31.1 175.1C31.1 168.9 32.58 161.9 33.7 155.1L11.52 135.3C4.458 128.1 1.62 119 5.324 110.3C7.592 104.1 10.13 99.79 12.91 94.76L15.95 89.51C18.98 84.46 22.28 79.58 25.82 74.89C31.52 67.34 41.54 64.83 50.53 67.79L78.75 77.09C89.5 68.25 101.7 61.13 114.1 56.15L121 27.08C122.1 17.8 130.2 10.37 139.6 9.231C146.3 8.418 153.1 8 160 8C166.9 8 173.7 8.418 180.4 9.23C189.8 10.37 197 17.8 198.1 27.08L205 56.15C218.3 61.13 230.5 68.25 241.2 77.09L269.5 67.79C278.5 64.83 288.5 67.34 294.2 74.89C297.7 79.56 300.1 84.42 304 89.44L307.1 94.83C309.9 99.84 312.4 105 314.7 110.3C318.4 119 315.5 128.1 308.5 135.3L286.3 155.1zM160 127.1C133.5 127.1 112 149.5 112 175.1C112 202.5 133.5 223.1 160 223.1C186.5 223.1 208 202.5 208 175.1C208 149.5 186.5 127.1 160 127.1zM484.9 478.3C478.1 479.4 471.1 480 464 480C456.9 480 449.9 479.4 443.1 478.3L423.3 500.5C416.1 507.5 407 510.4 398.3 506.7C393 504.4 387.8 501.9 382.8 499.1L377.4 496C372.4 492.1 367.6 489.7 362.9 486.2C355.3 480.5 352.8 470.5 355.8 461.5L365.1 433.2C356.2 422.5 349.1 410.3 344.1 397L315.1 390.1C305.8 389 298.4 381.8 297.2 372.4C296.4 365.7 296 358.9 296 352C296 345.1 296.4 338.3 297.2 331.6C298.4 322.2 305.8 314.1 315.1 313L344.1 306.1C349.1 293.7 356.2 281.5 365.1 270.8L355.8 242.5C352.8 233.5 355.3 223.5 362.9 217.8C367.6 214.3 372.5 210.1 377.5 207.9L382.8 204.9C387.8 202.1 392.1 199.6 398.3 197.3C407 193.6 416.1 196.5 423.3 203.5L443.1 225.7C449.9 224.6 456.9 224 464 224C471.1 224 478.1 224.6 484.9 225.7L504.7 203.5C511 196.5 520.1 193.6 529.7 197.3C535 199.6 540.2 202.1 545.2 204.9L550.5 207.9C555.5 210.1 560.4 214.3 565.1 217.8C572.7 223.5 575.2 233.5 572.2 242.5L562.9 270.8C571.8 281.5 578.9 293.7 583.9 306.1L612.9 313C622.2 314.1 629.6 322.2 630.8 331.6C631.6 338.3 632 345.1 632 352C632 358.9 631.6 365.7 630.8 372.4C629.6 381.8 622.2 389 612.9 390.1L583.9 397C578.9 410.3 571.8 422.5 562.9 433.2L572.2 461.5C575.2 470.5 572.7 480.5 565.1 486.2C560.4 489.7 555.6 492.1 550.6 496L545.2 499.1C540.2 501.9 534.1 504.4 529.7 506.7C520.1 510.4 511 507.5 504.7 500.5L484.9 478.3zM512 352C512 325.5 490.5 304 464 304C437.5 304 416 325.5 416 352C416 378.5 437.5 400 464 400C490.5 400 512 378.5 512 352z"
            fill="#FFFFFF"
          />
        </svg>
      </div>
      <Poem
        :selected="selected"
        :z-index="state"
        :fadeout="fadeout ? 'shown' : 'fadeout'"
      />
      <Poem
        :selected="nextpoem"
        :z-index="state2"
        :fadeout="fadeout ? 'fadeout' : 'shown'"
      />

      <div class="buttons">
        <div class="swipe__info">
          &#x3c; swipe for new Poem &#x3e;
        </div>
        <!-- <ion-button expand="block" @click="getNext()">Next</ion-button><br /> -->
        <ion-button expand="block" @click="addPoem()">Submit Poem</ion-button>
      </div>
      <div class="new__poem" :class="{ 'new__poem--show': newPoem }">
        <!-- Textarea in an item with a placeholder -->
        <ion-input
          v-model="poem.title"
          spellcheck="true"
          inputmode="text"
          autocapitalize="."
          placeholder="Enter Title"
          :required="true"
        ></ion-input>
        <ion-textarea
          v-model="poem.body"
          spellcheck="true"
          inputmode="text"
          placeholder="Enter Poem"
          autocapitalize="."
          :required="true"
        ></ion-textarea>
        <ion-input v-model="poem.author" placeholder="Enter Author"></ion-input>
        <ion-button expand="block" @click="submit()">Submit</ion-button>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonContent,
  IonPage,
  IonTextarea,
  IonButton,
  IonInput,
  createGesture,
  modalController,
} from "@ionic/vue";

import Poem from "@/components/Poem.vue";
import Modal from "@/components/Modal.vue";

import { defineComponent } from "vue";

export default defineComponent({
  name: "Home",
  components: {
    IonContent,
    IonPage,
    IonTextarea,
    IonButton,
    IonInput,
    Poem,
  },
  data() {
    return {
      poems: [],
      poem: {
        title: "",
        body: "",
        author: "",
        category: "normal",
      },
      selected: {},
      nextpoem: {},
      images: [],
      newPoem: false,
      poemsCount: 0,
      paging: 0,
      loading: true,
      state: 0,
      state2: 1,
      fadeout: true,
      activeId: null,
      lang: localStorage.getItem("lang") || 1,
      config: null,
    };
  },
  mounted() {
    this.getPoems("init");
    const onMove = (detail) => {
      if (detail.type == "pan" && !this.loading) this.getNext();
    };
    const gesture = createGesture({
      el: document.body,
      onEnd: (detail) => {
        onMove(detail);
      },
    });
    gesture.enable();
    document.addEventListener("ionBackButton", (ev) => {
      ev.detail.register(10, () => {
        if (this.newPoem) {
          this.newPoem = false;
        }
      });
    });
    const myHeaders = new Headers();
    myHeaders.append("APIKEY", "SJP_VUE_APP");
    fetch("https://slamjampoem.de/api/config/lang", {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    })
      .then(async (response) => {
        if (response.ok) {
          const languages = await response.json();
          this.config = languages;
        }
      })
      .catch((e) => {
        console.log(e);
      });
  },
  methods: {
    async openConfig() {
      const modal = await modalController.create({
        component: Modal, //Modal is name of the component to render inside ionic modal
        componentProps: { selectedlang: this.lang, config: this.config },
      });
      return modal.present();
    },
    newopencheck() {
      if (this.newPoem) {
        this.newPoem = false;
      }
    },
    async getData(url = "") {
      const myHeaders = new Headers();
      myHeaders.append("APIKEY", "SJP_VUE_APP");
      myHeaders.append("LANG", this.lang);
      const response = await fetch(url, {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      })
        .then(async (response) => {
          if (response.ok) {
            this.loading = false;
            return await response.json();
          }
        })
        .catch((e) => {
          console.log(e);
        });

      return response; // parses JSON response into native JavaScript objects
    },
    async postData(url = "", data = {}) {
      const response = await fetch(url, {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: {
          //"Content-Type": "application/json",
          APIKEY: "SJP_VUE_APP",
          LANG: this.lang,
          "Content-Type": "application/x-www-form-urlencoded",
        },
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: JSON.stringify(data), // body data type must match "Content-Type" header
      });
      return response.json(); // parses JSON response into native JavaScript objects
    },
    submit() {
      this.newPoem = false;
      if (this.poem.body !== "")
        this.postData("https://slamjampoem.de/api/post", this.poem).then(() => {
          this.poem = {
            title: "",
            body: "",
            author: "",
            category: "normal",
            lang: this.lang,
          };
        });
      //http://localhost:3000/
      // this.poems.push(this.poem);
    },
    random(state) {
      if (this.poems.length == 0) {
        if (this.paging == 0) {
          this.getPoems();
        } else {
          this.getNextPoems();
        }
        return false;
      }
      const selectPoem = 0;
      let selectPoem2 = 0;

      const initpoem = this.poems[selectPoem];
      // console.log("poems before", this.poems);
      if (state == "init") {
        this.poems = this.arrayRemove(this.poems, initpoem);
        selectPoem2 = 1;
      }
      let image = "https://source.unsplash.com/1600x900/?nature";
      let image2 = "https://source.unsplash.com/1600x900/?nature";

      if (this.images) {
        if (state == "init") {
          image = this.images[selectPoem].urls.regular;
          this.images = this.arrayRemove(this.images, this.images[selectPoem]);
          image2 = this.images[selectPoem2].urls.regular;
          this.images = this.arrayRemove(this.images, this.images[selectPoem2]);
        } else if (!this.fadeout) {
          image2 = this.images[selectPoem].urls.regular;
          this.images = this.arrayRemove(this.images, this.images[selectPoem]);
        } else {
          image2 = this.images[selectPoem].urls.regular;
          this.images = this.arrayRemove(this.images, this.images[selectPoem]);
        }
      }
      if (state !== "init") {
        if (this.fadeout) {
          this.fadeout = false;
        } else {
          this.fadeout = true;
        }
      }

      setTimeout(() => {
        if (state == "init") {
          this.selected = {
            poem: initpoem,
            image: image,
          };
          this.nextpoem = {
            poem: this.poems[selectPoem2],
            image: image2,
          };
        } else if (!this.fadeout) {
          this.selected = {
            poem: this.poems[selectPoem2],
            image: image2,
          };
        } else {
          this.nextpoem = {
            poem: this.poems[selectPoem2],
            image: image2,
          };
        }

        this.poems = this.arrayRemove(this.poems, this.poems[selectPoem2]);
        // console.log("poems after", this.poems);
        this.loading = false;
      }, 400);
    },
    getRandomInt(max) {
      return Math.floor(Math.random() * max);
    },
    shuffle(array) {
      let currentIndex = array.length,
        randomIndex;

      // While there remain elements to shuffle...
      while (currentIndex != 0) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
          array[randomIndex],
          array[currentIndex],
        ];
      }

      return array;
    },
    arrayRemove(arr, value) {
      return arr.filter(function(ele) {
        return ele != value;
      });
    },
    getPoems(state) {
      this.getData("https://slamjampoem.de/api/posts").then((data) => {
        // console.log("DATA", data); // JSON data parsed by `data.json()` call
        this.images = data.images;
        this.poemsCount = data.poems.length;
        this.paging = data.paging;
        if (data.poems.length > 0) {
          this.poems = this.shuffle(data.poems);
          this.random(state);
        } else {
          this.selected = {
            poem: { body: "Leider noch kein Gedicht :(" },
            image: data.images[0].urls.regular,
          };
        }
      });
    },
    getNextPoems() {
      this.getData("https://slamjampoem.de/api/posts/" + this.poemsCount).then(
        (data) => {
          // console.log("DATA", data); // JSON data parsed by `data.json()` call
          this.poems = data.poems;
          this.images = data.images;
          this.paging = data.paging;
          if (data.paging == 0) {
            this.poemsCount = data.poems.length;
          } else {
            this.poemsCount += data.poems.length;
          }
          this.random();
        }
      );
    },
    getNext() {
      this.loading = true;
      this.random();
    },
    addPoem() {
      this.newPoem = true;
    },
  },
});
</script>

<style>
.poem {
  transition: all 0.5s ease;
}
.shown {
  opacity: 1;
}
.fadeout {
  opacity: 0;
}
.rectangle {
  width: 500px;
  height: 100px;
  background: rgba(0, 0, 255, 0.5);
  z-index: 5000;
  position: absolute;
}

.scroll-y {
  overflow-y: hidden !important;
}
.swipeListener {
  position: absolute;
  z-index: 9;
  bottom: 0;
  width: 100%;
  height: 100%;
}
.buttons {
  position: absolute;
  z-index: 20;
  bottom: 0;
  width: 100%;
  padding: 16px;
  max-width: 800px;
  left: 50%;
  transform: translateX(-50%);
}
.app {
  background: #000;
  overflow-y: hidden;
  --overflow: hidden;
}
.logo {
  font-family: "Caveat";
  position: absolute;
  z-index: 20;
  top: 0;
  left: 0;
  width: 100%;
  text-shadow: -1px -1px 0 #00000030, 1px -1px 0 #00000030, -1px 1px 0 #00000030,
    1px 1px 0 #00000030;
  text-align: center;
  font-size: 40px;
  padding-top: 16px;
  user-select: none;
}
.swipe__info {
  font-family: "Caveat";
  text-align: center;
  font-size: 18px;
  margin-bottom: 16px;
  user-select: none;
}

.native-textarea.sc-ion-textarea-md {
  min-height: 200px;
}
.logo span {
  font-size: 50px;
}
.logo__s {
  margin-right: 0px;
}
.logo__j {
  margin-right: -2px;
  margin-left: -2px;
}
.logo__p {
  margin-left: 3px;
  margin-right: -6px;
}

.config {
  position: absolute;
  z-index: 50;
  max-width: 800px;
  text-align: right;
  width: 100%;
  left: 50%;
  transform: translateX(-50%);
  padding-top: 16px;
  padding-right: 16px;
}
.config svg {
  position: relative;
  z-index: 500;
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.new__poem {
  position: absolute;
  z-index: 50;
  bottom: -100%;
  transition: all 0.5s ease;
  width: 100%;
  background: #000;
  padding: 32px;
  max-width: 800px;
  left: 50%;
  transform: translateX(-50%);
}
.new__poem--show {
  bottom: 0;
}
input,
textarea {
  border: 1px solid #fff;
}
#container {
  text-align: center;

  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

#container strong {
  font-size: 20px;
  line-height: 26px;
}

#container p {
  font-size: 16px;
  line-height: 22px;

  color: #8c8c8c;

  margin: 0;
}

#container a {
  text-decoration: none;
}
</style>
